module.exports = __webpack_public_path__ + "img/fashion_65.620f797b.jpg";